module.exports = __webpack_public_path__ + "img/timemachine.fd6ef880.png";